import File from '@/model/File';

class Image extends File
{
	public thumbnailPublicPath: string;

	public constructor(options: any)
	{
		super(options);

		this.thumbnailPublicPath = options.thumbnailPublicPath;
	}
}

export default Image;